import type { PGD } from "../types";

export const pgdClarithromycinSinusitis: PGD = {
  id: "pgd-6d-clari-sinusitis",
  reference: "6d",
  version: "1.0",
  drugRef: "clarithromycin",
  indication: "Acute sinusitis — penicillin allergy, not pregnant",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 12, max: 999 },
    pregnancyAllowed: false,
    breastfeedingAllowed: true,
  },
  duration: { days: 5 },
  doseBands: [
    {
      id: "clari-sinusitis-age12plus",
      resolveBy: "single",
      ageRange: { min: 12, max: 999 },
      dose: 500,
      frequency: "TWICE a day",
      formulations: [
        { formulationId: "clari-500-tab", instruction: "Take ONE 500mg tablet TWICE a day for 5 days", quantity: { count: 10, label: "10 tablets" } },
        { formulationId: "clari-250-tab", instruction: "Take TWO 250mg tablets TWICE a day for 5 days", quantity: { count: 20, label: "20 tablets" } },
        { formulationId: "clari-250-5ml", instruction: "Take 10mL (500mg) TWICE a day for 5 days", quantity: { bottles: 2, label: "2 × 70mL bottles" } },
        { formulationId: "clari-125-5ml", instruction: "Take 20mL (500mg) TWICE a day for 5 days", quantity: { bottles: 3, label: "3 × 70mL bottles" } },
      ],
    },
  ],
  // Pre-supply checks — items already covered by pathway pre-screening are omitted:
  // All exclusion checks handled upfront in the pathway (q_general_exclusions,
  // q_myasthenia_check, q_clari_screen). No post-selection checks needed.
  preSupplyChecks: [],
  cautions: [
    { id: "caution-breastfeeding", text: "Breastfeeding — monitor infant for GI disturbance and oral candida." },
    { id: "caution-taste", text: "Clarithromycin suspension can cause a bitter after-taste." },
  ],
  counselling: [
    "Take with or without food",
    "Tablets should be swallowed whole",
    "Complete the full 5-day course even if symptoms improve",
    "Seek advice if palpitations, syncope, severe diarrhoea, jaundice or allergic symptoms occur",
  ],
  counsellingPoints: [
    { text: "Take with or without food" },
    { text: "Tablets should be swallowed whole" },
    { text: "Complete the full 5-day course even if symptoms improve" },
    { text: "Seek advice if palpitations, syncope, severe diarrhoea, jaundice or allergic symptoms occur" },
  ],
  outcomeLinkRefs: ["target-rti-leaflet", "nhs-sinusitis"],
};
